/**
 * CommissionBadge Component
 * Displays commission rate as a badge
 * Used across all affiliate marketplace pages
 */

import React from 'react';
import { Chip } from '@mui/material';
import { AttachMoney as AttachMoneyIcon } from '@mui/icons-material';
import { useDarkMode } from '../../hooks/useDarkMode';

export interface CommissionBadgeProps {
  rate: number;
  type: 'percentage' | 'fixed';
  size?: 'small' | 'medium';
}

export default function CommissionBadge({ rate, type, size = 'small' }: CommissionBadgeProps) {
  const isDarkMode = useDarkMode();

  const label = type === 'percentage' ? `${rate}%` : `₩${rate.toLocaleString()}`;

  return (
    <Chip
      icon={<AttachMoneyIcon sx={{ fontSize: size === 'small' ? 14 : 18 }} />}
      label={label}
      size={size}
      sx={{
        bgcolor: isDarkMode ? '#1a472a' : '#e8f5e9',
        color: isDarkMode ? '#4caf50' : '#2e7d32',
        fontWeight: 600,
        fontSize: size === 'small' ? '0.75rem' : '0.875rem',
        '& .MuiChip-icon': {
          color: isDarkMode ? '#4caf50' : '#2e7d32',
        },
      }}
    />
  );
}
